import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import { batchRequest, getRequest } from '../../../../../../api/ApiService';
import { teamsEndpoint } from '../../../../../../api/Teams';
import Auth from '../../../../../../routes/Auth';

import { handleSelectChange, arrayUniqueFilter } from '../../../utils';

import { getProductNameColor, getProductRowColor } from '../../../../../../api/PerformanceFeedback';

import {
  Table,
  Row,
  Cell
} from '../../../components/ui';

import BannerLayout from '../../../layouts/banner';

class RevenuesStep2 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
      products: [],
      totalRevenues: 0
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, rounds, performanceFeedbacksGame } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    getRequest(
      teamsEndpoint()
    ).then(res => {
      const teamsToShowIds = performanceFeedbacksGame.find(i => i.type === "Expected revenue low").teams.filter(arrayUniqueFilter);

      const teams = res.body;
      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      batchRequest([
        `${process.env.REACT_APP_API_URL}team/products/?round_number=${activeRound}&team_id=${team_id}`,
        `${process.env.REACT_APP_API_URL}team/price_forecasts/?round_number=${activeRound}&team_id=${team_id}`,
        `${process.env.REACT_APP_API_URL}team/inventory_balances/?round_number=${activeRound}&team_id=${team_id}`,
      ]).then(res => {
        const products = res[0].body;
        const productsFiltered = products.filter(i => Number(i.round) === roundId);

        const priceForecasts = res[1].body;
        const inventoryBalances = res[2].body;

        let totalRevenues = 0;
        for (let i = 0; i <= productsFiltered.length - 1; i++) {
          const priceForecast = priceForecasts.find(j => j.product === productsFiltered[i].id);
          const inventoryBalance = inventoryBalances.find(j => j.product === productsFiltered[i].id);
          productsFiltered[i].selling_price = priceForecast
            ? Number(priceForecast.price || 0)
            : 0;
          productsFiltered[i].available_for_sale = inventoryBalance
            ? Number(inventoryBalance.available_for_sale || 0)
            : 0;
          productsFiltered[i].total_revenues = Math.round(productsFiltered[i].selling_price * productsFiltered[i].available_for_sale);
          totalRevenues += productsFiltered[i].total_revenues;
        }

        this.setState({
          loaded: true,
          teamsToShow,
          selectedTeamId: Number(team_id),
          allTeamsCount: teams.length,
          products: productsFiltered,
          totalRevenues,
        })
      })
        .catch(err => { });
    })
      .catch(err => { });
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  render() {
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
      products,
      totalRevenues
    } = this.state;

    const { previousShownErrors, gamesTargets } = this.props;

    const netRevenues = Number(gamesTargets[0].net_revenues || 0);

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="Revenues"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams set their product’s selling price and/or units available for sale too low to hit their revenue target`}
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <Fragment>
            <p>Cross-functional/coordination issues might exist with these teams since their product’s selling price (set by Marketing) and the units available for sale (set by Operations) resulted in an expected sales value that was lower than the revenue target of <b>${Number((netRevenues / 1000000).toFixed(2))}M</b>.</p>
            <p>In their round feedback, these teams were advised to consider the revenue target when making pricing and production decisions.</p>
          </Fragment>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Fragment>
            <Table>
              <Row background="#2a4169">
                <Cell color="#ffffff" />
                <Cell color="#ffffff">Selling Price</Cell>
                <Cell color="#ffffff">Available for Sale Inventory</Cell>
                <Cell color="#ffffff">Total Revenues</Cell>
              </Row>
              {products.map((product, index) => (
                <Row background={getProductRowColor(index)} key={index}>
                  <Cell color="rgba(0, 27, 59, 0.94)" background={getProductNameColor(index)}>{product.name}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">${product.selling_price.toFixed(2)}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{this.numberWithCommas(product.available_for_sale)}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">${this.numberWithCommas(product.total_revenues)}</Cell>
                </Row>
              ))}
              <Row>
                <Cell color="rgba(0, 27, 59, 0.94)">Total Revenues</Cell>
                <Cell />
                <Cell />
                <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">${this.numberWithCommas(totalRevenues)}</Cell>
              </Row>
            </Table>
          </Fragment>
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default RevenuesStep2;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/revenues/step2.js